import { render } from "./ProductEditor.vue?vue&type=template&id=06d87969"
import script from "./ProductEditor.vue?vue&type=script&lang=js"
export * from "./ProductEditor.vue?vue&type=script&lang=js"

import "./ProductEditor.vue?vue&type=style&index=0&id=06d87969&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__